import React from "react";
import Box from "@mui/material/Box";
// import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { UpdatePassword } from "../../components/profile/UpdatePassword";
import Divider from "@mui/material/Divider";

const UserPassword = () => {
  return (
    <Box component={Paper} elevation={0}>
      <Box textAlign={"center"} px={3} py={2}>
        <Typography variant='body3'>Update Password</Typography>
      </Box>
      <Divider />
      <Grid container px={5} py={5} spacing={3}>
        <Grid item lg={12} md={10} xs={16}>
          <UpdatePassword />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserPassword;
